import { Box } from '@mui/material';
import { _PADDING } from 'constants/common';
import { color } from 'theme';

/**
 * Component chức năng tìm kiếm cho từng trang của hệ thống
 * @param {*} param0 
 * @returns 
 */
const SearchPage = ({children, justifyContent = 'space-between', sx }) => {
    return (
        <Box component={'div'} id='search-page' 
          sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: justifyContent, 
              padding: { xs: `12px ${_PADDING.COMPONENT}`, sm: `12px ${_PADDING.COMPONENT}`},  
              backgroundColor: color.whiteF2, 
              maxHeight: {xs: 'unset', lg: '60px'},
              ...sx
              }}>
          {children}
        </Box>
    )
}

export default SearchPage